import { useQuery } from '@tanstack/react-query';
import { getAllDocumentSections } from '@/features/constructorDocuments/api/index';

export const useAllDocumentSections = () => {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: ['getAllDocumentSections'],
    queryFn: getAllDocumentSections,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error
  };
};
